import React, { useRef } from 'react';
import { Label } from '../../../../../../../common/labels/labelTypes';
import { useSelector } from 'react-redux';
import { getColorDefaultHexValue } from '../../../../../../../common/colors/elementColorFormatUtil';
import CustomColorInput from '../../colorTools/CustomColorInput';
import ColorPopupContent from '../../colorTools/popup/ColorPopupContent';
import { COLOR_POPUP_MODE } from '../../colorTools/popup/colorPopupConstants';
import { COLORS } from '../../../../../../../common/colors/colorConstants';
import currentBoardSuggestedColorSelectorOnlyColors from '../../colorTools/currentBoardSuggestedColorsSelector';

type LabelColorPickerProps = {
    label: Label;
    updateLabel: (changes: Partial<Label>) => void;
};

const LabelColorPicker: React.FC<LabelColorPickerProps> = ({ label, updateLabel }) => {
    const customColorInputRef = useRef<CustomColorInput>(null);
    const suggestedColors = useSelector(currentBoardSuggestedColorSelectorOnlyColors);

    const setColor = (color: string | null) => {
        if (!color) return;

        const colorToSave = getColorDefaultHexValue(color);

        updateLabel({ color: colorToSave });
    };

    const openCustomColorPicker = () => {
        if (!customColorInputRef?.current) return;

        customColorInputRef.current.open();
    };

    return (
        <>
            <CustomColorInput
                className="absolute opacity-0 pointer-events-none"
                ref={customColorInputRef}
                initialColor={label.color}
                setColor={setColor}
            />
            <ColorPopupContent
                supportBackgroundColor={false}
                supportColorBar={false}
                supportDualColors={false}
                setColor={setColor}
                selectedColor={label.color}
                colorPopupMode={COLOR_POPUP_MODE.COLOR}
                defaultColors={Object.values(COLORS)}
                suggestedColors={suggestedColors}
                openCustomColorPicker={openCustomColorPicker}
            />
        </>
    );
};

export default LabelColorPicker;
